// NOTICE:
// The upstream implementation picked one of three localized policy pages on the upstream
// docs site. Lumina publishes a single policy at one URL, so the locale argument is now
// accepted and ignored rather than removed: the callers are i18n-aware components that
// still pass their locale, and changing their call sites would be churn for no behaviour
// change. Restore locale selection here if Lumina ever publishes translated policies.
const LUMINA_PRIVACY_POLICY_URL = 'https://luminacorp.io/privacy'

export function getAnalyticsPrivacyPolicyUrl(_locale?: string): string {
  return LUMINA_PRIVACY_POLICY_URL
}
